import { parseTenantCodeFromHostname } from './instanceDefaults.js'

/** 全站默认产品品牌 */
export const DEFAULT_BRANDING = {
  productName: 'DMe',
  copyrightName: 'DMe',
  slogan: '懂你的股东智能决策系统',
  logoUrl: '/brand/gem-icon.png',
  logoCaption: '杰门科技',
  logoAlt: 'DMe',
  useLogoImage: true,
}

/** 按租户代码覆盖（可选；未配置则使用 DEFAULT_BRANDING） */
const TENANT_BRAND_OVERRIDES = {}

export function getBrandingForTenantCode(code) {
  const key = (code || '').toString().trim()
  const override = TENANT_BRAND_OVERRIDES[key]
  return override ? { ...DEFAULT_BRANDING, ...override } : { ...DEFAULT_BRANDING }
}

export function resolveBrandingFromWindow() {
  if (typeof window === 'undefined') return { ...DEFAULT_BRANDING }
  const code = parseTenantCodeFromHostname(window.location.hostname)
  return getBrandingForTenantCode(code)
}
